// src/api/axiosInstance.js
import axios from 'axios';

const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:3000'; // fallback for dev

const axiosInstance = axios.create({
  baseURL,
  timeout: 60000,
});

// Add request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // Make sure headers object exists
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Optional: handle global errors (401, 403, etc.)
    if (error.response && error.response.status === 401) {
      console.warn('Unauthorized! Redirect to login if needed.');
      // e.g., localStorage.clear(); window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;







// // src/api/axiosInstance.js
// import axios from 'axios';

// const baseURL = import.meta.env.VITE_API_CONNECTPLUS 
// const axiosInstance = axios.create({
//   baseURL: '/connectplus', // relative path; Vite handles proxy
//   timeout: 60000,
// });

// // Add request interceptor
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       // Make sure headers object exists
//       config.headers = config.headers || {};
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Add response interceptor
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Optional: handle global errors (401, 403, etc.)
//     if (error.response && error.response.status === 401) {
//       console.warn('Unauthorized! Redirect to login if needed.');
//       // e.g., localStorage.clear(); window.location.href = '/login';
//     }
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;



